
export function updateCounts(event, minCount, userHasCount) {
  if (!userHasCount) {
    return 0;
  }
  const value = parseInt(event.target.value);
  if (value < minCount) {
    return minCount;
  }
  if (value > userHasCount) {
    return userHasCount;
  }
  return event.target.value;
}
